export const AddressAdapter = ((data) => {
  return {
    street1: data.street1,
    streetNumber: data.streetNumber,
    apartament: data.apartament,
    neighborhoodId: parseInt(data.neighborhood),
    streetType: parseInt(data.streetType),
    // curp: data.curp
  }
})